import classNames from "classnames";
import { observer } from "mobx-react";
import React from "react";
import { useStore } from "../../models";
import { ToastMessageType } from "../../models/ui";
import { IToastBarMessage, ToastBarToastType } from "../../models/ui/toastModels";
import styles from "./toastBar.css";

export const ToastBar = observer(() => {
  const { uiStore } = useStore();

  const render = (toast: IToastBarMessage) => {
    const isDismissable = toast.toastBarToastType !== ToastBarToastType.NoConnection;

    return (
      <div
        className={classNames(styles.container, {
          [styles["payment-success"]]: toast.type === ToastMessageType.PAYMENT,
          [styles.error]: toast.type === ToastMessageType.DANGER,
          [styles.info]: toast.type === ToastMessageType.INFO
        })}
      >
        <span dangerouslySetInnerHTML={{ __html: toast.message }} />
        {isDismissable && (
          <button className={styles.dismiss} onClick={() => uiStore.removeToastBarMessage()}>
            <i className="icon-close-cross" />
          </button>
        )}
      </div>
    );
  };

  if (!uiStore.toastBarMessage) {
    return <></>;
  }
  return render(uiStore.toastBarMessage);
});
